// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchNotifications,
  createNotification,
  readNotification,
} from "../../api/notificationApi";

// Async thunks for notification operations

export const getNotifications = createAsyncThunk(
  "notification/getNotifications",
  async (_, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchNotifications();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getNotificationById = createAsyncThunk(
  "notification/getNotificationById",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await readNotification(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createNewNotification = createAsyncThunk(
  "notification/createNotification",
  async (
    newNotification: {
      id: string;
      receiver_id: string;
      title: string;
      message: string;
      type: string;
    },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await createNotification(newNotification);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// New thunk for marking a notification as read
export const markNotificationRead = createAsyncThunk(
  "notification/markNotificationRead",
  async (id: string, { dispatch, rejectWithValue }) => {
    try {
      return await readNotification(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Notification Slice

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    notifications: [] as any[],
    notification: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all notifications
      .addCase(
        getNotifications.fulfilled,
        (state, action: PayloadAction<any[]>) => {
          state.status = true;
          state.notifications = action.payload?.data;
        }
      )
      .addCase(getNotifications.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Get notification by ID
      .addCase(
        getNotificationById.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = true;
          state.notification = action.payload;
        }
      )
      .addCase(getNotificationById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Create notification
      .addCase(
        createNewNotification.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.notifications.push(action.payload);
          state.status = true;
          state.msg = "Notification created successfully.";
        }
      )
      .addCase(createNewNotification.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Mark notification as read
      .addCase(
        markNotificationRead.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = true;
          // // console.log(action.meta.arg, "action.meta.arg");

          state.msg = "Notification marked as read.";
          //   const index = state.notifications.findIndex(
          //     (notification) => notification._id === action.meta.arg
          //   );
          //   // // console.log(index,'index');

          //   if (index !== -1) {
          state.notifications = state.notifications.filter(
            (notification) => notification._id !== action.meta.arg
          );
          //   }
        }
      )
      .addCase(markNotificationRead.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetStatus } = notificationSlice.actions;
export default notificationSlice.reducer;
